import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
const PrivateRoute = ({ element }) => {
  console.log("checking coooooookies");
  const cookie = sessionStorage.getItem("user");
  // return element;
  return cookie ? element : <Navigate to="/login" replace />;
};

export default PrivateRoute;
